import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IPositionCorrectionObject } from "../objects";
import { AbstractRectangleCoordinatableObjectEditor } from "./AbstractRectangleCoordinatableObjectEditor";

export class PositionCorrectionObjectEditor extends AbstractRectangleCoordinatableObjectEditor<IPositionCorrectionObject> {
  constructor(source: IPositionCorrectionObject | PositionCorrectionObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
  }

  getTypeName(): string {
    return "位置補正";
  }

  clone(): IFormatObjectEditable {
    return new PositionCorrectionObjectEditor(this);
  }
}
